import React from "react";
import { Switch, Route } from "react-router";
import StartPage from "../startPage/startPage";
import Season from "../season/season";
import Live from "../live/live";
import Article from "../article/article";
import Watch from "../watch/watch.js";
import Detail from "../movieDetail/detail";
import NormalPage from "../normalpage/normalPage";
import NotFound from "../notfound/notfound";
import TextDoc from "../text/textDoc";
import Page from "../startPage/page";
import Landing from "../landing/landing";
import Login from "../login/login";
import Register from "../login/register";
import Global from "../../global";
import User from "../api/user";
import PrivateRoute from "./privateRoute";
import PublicRoute from "./publicRoute";
import ScrollToTop from "./scroll";
import VerifyOtp from "../login/verifyOtp";
import SendOtp from "../login/sendOtp";
import UnFreeRoute from "./unfreeRoute";
import FreeRoute from "./freeRoute";
import Profile from "../profile/profile";
import Favourites from "../favourites/favourites";
import WatchGroup from "../history/WatchList";
import Search from "../search/search";
import Payment from "../payment/payment";
import Plans from "../pricing/premium";
import Status from "../payment/status";
import SubscribeRoute from "./subscribeRoute";
import CommonRoute from "./commonRoute";
import Test from "../test";

const PageRouter = (props) => {
  if (Global.LOGIN && Global.SUBSCRIPTION) {
    //Landing Page

    return (
      <div className="App">
        <ScrollToTop>
          <Switch>
            <CommonRoute
              exact
              path="/:AppId/welcome"
              component={Landing}
            ></CommonRoute>

            <Route
              exact
              path="/:AppId/premium"
              render={(props) => <Plans {...props}></Plans>}
            ></Route>
            <PrivateRoute
              exact
              path="/:AppId/payment"
              component={Payment}
            ></PrivateRoute>

            <PrivateRoute
              exact
              path="/:AppId/payment/status/:flag"
              component={Status}
            ></PrivateRoute>

            <CommonRoute
              exact
              path="/:AppId/login"
              component={Login}
            ></CommonRoute>
            <CommonRoute
              exact
              path="/:AppId/register"
              component={Register}
            ></CommonRoute>
            <PrivateRoute
              exact
              path="/:AppId/profile"
              component={Profile}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/verify"
              component={VerifyOtp}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/sendotp"
              component={SendOtp}
            ></PrivateRoute>

            <SubscribeRoute
              exact
              path="/:AppId/search/:searchId"
              component={Search}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId/search/"
              component={Search}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId/favourites"
              component={Favourites}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId/watchhistory"
              component={WatchGroup}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId/:urlName"
              component={StartPage}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId"
              component={StartPage}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId/"
              component={StartPage}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId/page/:Id"
              component={StartPage}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId/detail/:Id"
              component={Season}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId/info/:Id"
              component={Season}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId/videoPage/:Id"
              component={Detail}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId/watch/:Id"
              component={Watch}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId/:Type/:TypeId/watch/:Id"
              component={Watch}
            ></SubscribeRoute>
            <SubscribeRoute
              exact
              path="/:AppId/:Type/:TypeId/watch/:Id/:offset"
              component={Watch}
            ></SubscribeRoute>
            <Route
              exact
              path="/"
              render={(props) => (
                <NotFound
                  code={"500 ERROR"}
                  message={"APPLICATION ID IS WRONG OR MISSING"}
                ></NotFound>
              )}
            ></Route>
          </Switch>
        </ScrollToTop>
      </div>
    );
  } else if (Global.LOGIN && !Global.SUBSCRIPTION) {
    //Login
    return (
      <div className="App">
        <ScrollToTop>
          <Switch>
            <PrivateRoute
              exact
              path="/:AppId"
              component={StartPage}
            ></PrivateRoute>

            <PublicRoute
              exact
              path="/:AppId/welcome"
              component={Landing}
            ></PublicRoute>

            <PublicRoute
              exact
              path="/:AppId/user"
              component={User}
            ></PublicRoute>

            {/* <PrivateRoute exact path ="/:AppId/premium" component = {Pricing} ></PrivateRoute> */}
            <Route
              exact
              path="/:AppId/premium"
              render={(props) => <Plans {...props}></Plans>}
            ></Route>

            <Route
              exact
              path="/:AppId/premium/:AssetId"
              render={(props) => <Plans {...props}></Plans>}
            ></Route>

            <PrivateRoute
              exact
              path="/:AppId/payment"
              component={Payment}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/payment/status/:flag"
              component={Status}
            ></PrivateRoute>

            <PublicRoute
              exact
              path="/:AppId/login"
              component={Login}
            ></PublicRoute>

            <PublicRoute
              exact
              path="/:AppId/register"
              component={Register}
            ></PublicRoute>
            <PrivateRoute
              exact
              path="/:AppId/verify"
              component={VerifyOtp}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/sendotp"
              component={SendOtp}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/profile"
              component={Profile}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/search/:searchId"
              component={Search}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/search/"
              component={Search}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/favourites"
              component={Favourites}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/watchhistory"
              component={WatchGroup}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/:urlName"
              component={StartPage}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/page/:Id"
              component={Page}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/seasonPage/:videoId"
              component={Season}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/livePage/:Id"
              component={Live}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/articlePage/:Id"
              component={Article}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/normalPage/:Id"
              component={NormalPage}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/textPage/:Id"
              component={TextDoc}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/videoPage/:Id"
              component={Detail}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/watch/:Id"
              component={Watch}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/:Type/:TypeId/watch/:Id"
              component={Watch}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/:Type/:TypeId/watch/:Id/:offset"
              component={Watch}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/:Type/watch/:Id"
              component={Watch}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/detail/:Id"
              component={Season}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path="/:AppId/info/:Id"
              component={Season}
            ></PrivateRoute>

            {/* <Route
              exact
              path="/"
              render={(props) => (
                <NotFound
                  code={"500 ERROR"}
                  message={"APPLICATION ID IS WRONG OR MISSING"}
                ></NotFound>
              )}
            ></Route> */}
          </Switch>
        </ScrollToTop>
      </div>
    );
  } else if (!Global.LOGIN && Global.SUBSCRIPTION) {
    //Home
    return (
      <div className="App">
        <ScrollToTop>
          <Switch>
            <Route
              exact
              path="/:AppId"
              render={(props) => <StartPage {...props} menu={"home"} />}
            ></Route>

            <Route
              exact
              path="/:AppId/user"
              render={(props) => <User {...props}></User>}
            ></Route>

            <Route
              exact
              path="/:AppId/upcoming"
              render={(props) => <Test></Test>}
            ></Route>

            <Route
              exact
              path="/:AppId/premium"
              render={(props) => <Plans {...props}></Plans>}
            ></Route>

            <Route
              exact
              path="/:AppId/premium/:AssetId"
              render={(props) => <Plans {...props}></Plans>}
            ></Route>

            <FreeRoute exact path="/:AppId/login" component={Login}></FreeRoute>
            <FreeRoute
              exact
              path="/:AppId/register"
              component={Register}
            ></FreeRoute>
            <UnFreeRoute
              exact
              path="/:AppId/verify"
              component={VerifyOtp}
            ></UnFreeRoute>
            <UnFreeRoute
              exact
              path="/:AppId/payment"
              component={Payment}
            ></UnFreeRoute>
            <UnFreeRoute
              exact
              path="/:AppId/payment/status/:flag"
              component={Status}
            ></UnFreeRoute>
            <UnFreeRoute
              exact
              path="/:AppId/sendotp"
              component={SendOtp}
            ></UnFreeRoute>
            <UnFreeRoute
              exact
              path="/:AppId/profile"
              component={Profile}
            ></UnFreeRoute>
            <UnFreeRoute
              exact
              path="/:AppId/favourites"
              component={Favourites}
            ></UnFreeRoute>
            <UnFreeRoute
              exact
              path="/:AppId/watchhistory"
              component={WatchGroup}
            ></UnFreeRoute>
            <Route
              exact
              path="/:AppId/:urlName"
              render={(props) => <StartPage {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/page/:Id"
              render={(props) => <Page {...props} menu={"home"} />}
            ></Route>

            <Route
              exact
              path="/:AppId/search/:searchId"
              render={(props) => <Search {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/search/"
              render={(props) => <Search {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/seasonPage/:videoId"
              render={(props) => <Season {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/livePage/:Id"
              render={(props) => <Live {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/articlePage/:Id"
              render={(props) => <Article {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/normalPage/:Id"
              render={(props) => <NormalPage {...props} menu={"home"} />}
            ></Route>

            <Route
              exact
              path="/:AppId/textPage/:Id"
              render={(props) => <TextDoc {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/videoPage/:Id"
              render={(props) => <Detail {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/watch/:Id"
              render={(props) => <Watch {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/:Type/:TypeId/watch/:Id"
              render={(props) => <Watch {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/:Type/:TypeId/watch/:Id/:offset"
              render={(props) => <Watch {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/:Type/watch/:Id"
              render={(props) => <Watch {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/detail/:Id"
              render={(props) => <Season {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/info/:Id"
              render={(props) => <Season {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/"
              render={(props) => (
                <NotFound
                  code={"500 ERROR"}
                  message={"APPLICATION ID IS WRONG OR MISSING"}
                ></NotFound>
              )}
            ></Route>
          </Switch>
        </ScrollToTop>
      </div>
    );
  } else {
    return (
      <div className="App">
        <ScrollToTop>
          <Switch>
            <Route
              exact
              path="/:AppId"
              render={(props) => <StartPage {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/upcoming"
              render={(props) => <Test></Test>}
            ></Route>
            <Route
              exact
              path="/:AppId/:urlName"
              render={(props) => <StartPage {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/page/:Id"
              render={(props) => <Page {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/seasonPage/:videoId"
              render={(props) => <Season {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/livePage/:Id"
              render={(props) => <Live {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/articlePage/:Id"
              render={(props) => <Article {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/normalPage/:Id"
              render={(props) => <NormalPage {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/search/:searchId"
              render={(props) => <Search {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/search/"
              render={(props) => <Search {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/textPage/:Id"
              render={(props) => <TextDoc {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/videoPage/:Id"
              render={(props) => <Detail {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/watch/:Id"
              render={(props) => <Watch {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/:Type/:TypeId/watch/:Id"
              render={(props) => <Watch {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/:Type/:TypeId/watch/:Id/:offset"
              render={(props) => <Watch {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/:Type/watch/:Id"
              render={(props) => <Watch {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/detail/:Id"
              render={(props) => <Season {...props} menu={"home"} />}
            ></Route>
            <Route
              exact
              path="/:AppId/info/:Id"
              render={(props) => <Season {...props} menu={"home"} />}
            ></Route>

            {/* <Route
              exact
              path="/"
              render={(props) => (
                <NotFound
                  code={"500 ERROR"}
                  message={"APPLICATION ID IS WRONG OR MISSING"}
                ></NotFound>
              )}
            ></Route> */}
          </Switch>
        </ScrollToTop>
      </div>
    );

    //Home
  }
};

export default PageRouter;
